import React, { useState } from "react";
import { PageHeader as MyPageHeader, Button } from "antd";
import { useHistory } from "react-router-dom";
import strings from "../../utils/Localization";
import { PlusOutlined } from "@ant-design/icons";
import KasaEkleModal from "../kasa/KasaEkleModal";

export default function PageHeader() {
  const [kasaEkleModalVisible, setKasaEkleModalVisible] = useState(false);
  const history = useHistory();
  const { pageHeader } = strings.kasaListe.components;

  return (
    <>
      <MyPageHeader
        ghost={false}
        onBack={() => history.goBack()}
        title={pageHeader.baslik}
        subTitle={pageHeader.altBaslik}
        extra={[
          <Button
            onClick={() => setKasaEkleModalVisible(true)}
            type="primary"
            size="large"
            icon={<PlusOutlined />}
          >
            {pageHeader.kasaEkleButon}
          </Button>,
        ]}
      />
      <KasaEkleModal
        visible={kasaEkleModalVisible}
        handleCancel={() => setKasaEkleModalVisible(false)}
      />
    </>
  );
}
